module.exports = __webpack_public_path__ + "static/media/movieBG.f591d46e.png";